module.exports = __webpack_public_path__ + "static/media/az.813b524a.svg";